export default class PostsCountDiscussionModel {
    public id: string = "";
    public postsCount: number = 0;
}